module.exports = {
	"10s": "10s",
	"10ss": "10",
	"9s": "9s",
	"9ss": "9",
	"ABOUT": "عن",
	"ABOUT_ME": "عني",
	"ACTIONS": "الاحداث",
	"ACTIVE": "فعال",
	"ACTIVE_ATHLETES": "الرياضيين الفاعلين",
	"ADD": "إضافة",
	"ADDRESS": "العنوان",
	"ADD_ELIMINATION_LEAGUE": "إضافة دوري",
	"ADD_GAME": "إضافة مباراة",
	"ADD_GAME_QUICKSTART": "إضافة مباراة",
	"ADD_LEAGUE": "إضافة فئة",
	"ADD_NEW": "إضافة جديد",
	"ADD_NEW_PAYMENT": "إضافة دفعة جديدة",
	"ADD_OLYMPIC_SHOTS": "إضافة رميات جولات تصفيات",
	"ADD_PASSPORT": "إضافة جواز سفر",
	"ADD_PAYMENT": "إضافة دفعة",
	"ADD_PAYMENT_PLAYER": "دفعات اللاعب",
	"ADD_PAYMENT_REASON": "إضافة سبب الدفعة",
	"ADD_PAYMENT_TEAM": "دفعات الفريق",
	"ADD_PLAYER": "إضافة لاعب",
	"ADD_PLAYERS": "إضافة لاعبين",
	"ADD_PLAYERS_TO_MATCH": "إضافة لاعبين للبطولة",
	"ADD_PLAYERS_TO_TEAM": "إضافة لاعبين للفريق",
	"ADD_PLAYER_PAYMENT": "إضافة دفعة جديدة للاعب",
	"ADD_PLAYER_TO_MATCH": "إضافة لاعب للبطولة",
	"ADD_REMOVE_PLAYERS": "إضافة/حذف لاعبين",
	"ADD_SHOTS": "إضافة رميات",
	"ADD_SHOTS_INDIVIDUAL": "إضافة رميات للاعبين الافراد",
	"ADD_SHOTS_MIXED_TEAM": "إضافة رميات للفريق المختلط",
	"ADD_SHOTS_OLYMPIC": "إضافة رميات جولات ",
	"ADD_SHOTS_P1": "إضافة رميات لاعب 1",
	"ADD_SHOTS_P2": "إضافة رميات لاعب 2",
	"ADD_SHOTS_P3": "إضافة رميات لاعب 3",
	"ADD_SHOTS_TEAM": "إضافة رميات الفريق",
	"ADD_SHOTS_TO_GAME": "إضافة رميات للمباراة",
	"ADD_SHOTS_VISUAL": "تحديث بصري للرميات على الهدف",
	"ADD_TEAM": "إضافة فريق",
	"ADD_TEAM_PAYMENT": "إضافة دفعة جديدة للفريق",
	"ADD_TRAINING_ENTRIES": "إضافة التسجيل للتدريب",
	"ADD_WITHOUT_DETAILS": "إضافة بدون تفاصيل",
	"ADD_WITH_DETAILS": "إضافة مع التفاصيل",
	"ADD_WITH_FILE": "إضافة مع ملف",
	"ADMIN": "المدير",
	"ADT": "ADT",
	"AD_BLOCK_MESSAGE": "للاستخدام الصحيح يرجى تعطيل مانع الإعلانات في متصفحك.",
	"AFM": "ضريبه القيمه المضافه",
	"AFTER_SCOREING": "بعد نهاية الرمي",
	"AGE": "العمر ( يساوي او اكبر )",
	"ALL_ATHLETES": "جميع الرياضيين",
	"ALL_PLAYERS": "جميع اللاعبين",
	"ALL_TARGETS": "جميع الاهداف",
	"ALPHA_LIST_GAME": "طباعة مباراة الرياضيين مع الأهداف",
	"ALREADY_ACTIVE_SESSION": "هناك بالفعل جلسة نشطة. إنهاء هذه أولاً",
	"AMEA": "ذوي الإعاقة",
	"AMEA_TEAM": "فريق بارا‘",
	"AMOUNT": "مبلغ",
	"AMOUNT_PAID": "المبلغ المدفوع",
	"AMS_CODE": "الكود",
	"ARCHER": "الرامي",
	"ARE_YOU_SURE_UPDATE_GAME": "هل أنت متأكد من تحديث المباراة?",
	"ARROW": "السهم",
	"ARROWS": "الاسهم",
	"ARROW_NOW": "السهم الان",
	"ATHLETE": "الرياضي",
	"ATHLETES_SCORECARDS": "الرياضيين بطاقات نتائج",
	"AUTHORIZATION_KEY": "رمز التفويض",
	"AVAILABLE": "متاح",
	"BACK": "العودة",
	"BIRTH": "تاريخ الميلاد",
	"BIRTHDATE": " تاريخ الميلاد",
	"BIRTH_DATE": " تاريخ الميلاد ",
	"BIRTH_PLACE": "مكان الميلاد",
	"BOW_TYPE": "نوع القوس",
	"BRONZE": "برونز",
	"C": "C",
	"CALENDAR": "التقويم",
	"CANCEL": "الغاء",
	"CANCEL_PAYMENT": "الغاء الدفعة",
	"CAPTAIN": "الكابتن",
	"CATEGORY": "فئة",
	"CATEGORY_S": "فئات",
	"CHANGE_MATCH": "تغيير البطولة",
	"CHANGE_PASSWORD": "تغيير كلمة المرور",
	"CHANGE_TEAM_PASSWORD": "تغيير كلمة مرور الفريق",
	"CHANGE_USER_PASSWORD": "تغيير كلمة مرور المستخدم",
	"CHECK_THIS_FOR_ALL": "تحقق من هذا لجميع البطولات",
	"CHOOSE_PLAYERS": "اختيار الرياضيين",
	"CITIZENSHIP": "مواطن",
	"CITY": "المدينة",
	"CL1": "CL1",
	"CL2": "CL2",
	"CLEAR_ROUND": "مسح رميات الجولة",
	"CLEAR_SHOTS": "مسح الرميات ",
	"CLOSED": "مغلق",
	"CLOSER_TO_CENTER": "أقرب إلى المركز",
	"CLOSE_REGISTRATION": "إغلاق التسجيلات",
	"COACH": "مدرب",
	"COACHES": "المدربين",
	"COACH_0_LEVEL": "مدرب مبتديء",
	"COACH_A_LEVEL": "مدرب مستوى أ",
	"COACH_B_LEVEL": "مدرب مستوى ب ",
	"COACH_C_LEVEL": "مدرب مستوى ج ",
	"COACH_EMAIL": "ايميل المدرب",
	"COACH_LEVEL": "مستوى المدرب",
	"COACH_OF": "مدرب الـ ",
	"COACH_PROFILE": "ملف المدرب",
	"CODE": "الكود",
	"COMMENTS": "الملاحظات ",
	"COMMITTEE": "اللجنة",
	"COMPANION": "المرافق",
	"COMPETED_IN": "للتنافس في",
	"COMPOUND": "قوس مركب",
	"COMPOUND_JM_JW": "قوس مركب للناشئين اولاد - بنات",
	"COMPOUND_LEVEL": "مستوى القوس المركب",
	"COMPOUND_M_W": " قوس مركب رجال - سيدات ",
	"COMPOUND_YM_YW": " قوس مركب للشباب اولاد - بنات ",
	"CONFIRM": "تأكيد",
	"CONFIRM_CLEAR_TARGETS": "هل أنت متأكد من أنك تريد مسح الأهداف؟",
	"CONFIRM_DELETE_COACH": "هل أنت متأكد من أنك تريد حذف هذا المدرب؟",
	"CONFIRM_DELETE_ELIMINATION_MATCH": "هل أنت متأكد من أنك تريد حذف الدور الاقصائي هذا؟",
	"CONFIRM_DELETE_JUDGE": "هل أنت متأكد من أنك تريد حذف هذا الحكم؟",
	"CONFIRM_DELETE_LEAGUE": "هل أنت متأكد من أنك تريد حذف هذا الفئة؟",
	"CONFIRM_DELETE_MATCH": "هل أنت متأكد من أنك تريد حذف هذه البطولة؟",
	"CONFIRM_DELETE_PAYMENT": "هل أنت متأكد من أنك تريد حذف هذه الدفعة؟",
	"CONFIRM_DELETE_PLAYER": "هل أنت متأكد من أنك تريد حذف هذا الرياضي؟",
	"CONFIRM_DELETE_TEAM": "هل أنت متأكد من أنك تريد حذف هذا الفريق؟",
	"CONFIRM_DELETE_TRAINER": "هل أنت متأكد من أنك تريد حذف هذا المدرب؟",
	"CONFIRM_DELETE_TRAINING_CENTER": "حذف مركز التدريب؟",
	"CONFIRM_MOVE_LEAGUES": "هل أنت متأكد من أنك تريد نقل هذه الفئات؟",
	"CONFIRM_REMOVE_LEAGUE_FROM_MATCH": "هل أنت متأكد من أنك تريد إزالة هذه الفئة من البطولة ؟",
	"CONFIRM_REMOVE_PLAYER_FROM_MATCH": "هل أنت متأكد من أنك تريد إزالة هذا الرياضي من البطولة؟",
	"CONTRACT_DATE": "تاريخ انتهاء العقد",
	"COUNTY": "المنطقة",
	"CREATE": "إنشاء",
	"CREATED_AT": "تم إنشائه في",
	"CREATE_COACH": "إضافة مدرب",
	"CREATE_JUDGE": "إضافة حكم",
	"CREATE_LEAGUE": "إنشاء فئة",
	"CREATE_MATCH": "إنشاء بطولة ",
	"CREATE_PLAYER": "إنشاء لاعب",
	"CREATE_ROLE": "قاعدة جديدة",
	"CREATE_TEAM": "إنشاء فريق",
	"CREATE_TRAINER": "إضافة مدرب ",
	"CREATE_TRAINING_CENTER": "إنشاء مركز تدريب",
	"CREATE_USER": "مستخدم جديد",
	"CURRENT_ACTIVE_INSIDE": "حاليا داخل مركز التدريب",
	"CURRENT_LIST": "القائمة الحالية",
	"CURRENT_PLAYERS": "الرياضيون الحاليون",
	"CURRENT_RESULTS_PDF": "النتائج الحالية",
	"CURRENT_ROUND": "الجولة الحالية",
	"CUSTOM": "مخصص",
	"DASHBOARD": "لوحة التحكم",
	"DATE": "التاريخ",
	"DATE_FILED": "حقل التاريخ",
	"DATE_FROM": "من تاريخ",
	"DATE_TO": "الى تاريخ",
	"DAYS": "الايام",
	"DAYS_LEFT": "الأيام المتبقية",
	"DEGREE_SETTINGS": "إعدادات الدرجة",
	"DELETE": "حذف",
	"DELETE_GAME": "حذف الجولة",
	"DELETE_LEAGUE": "حذف الفئة",
	"DELETE_PLAYER": "حذف رياضي",
	"DELETE_TEAM": "حذف الفريق",
	"DELETE_TRAINING_ENTRY": "حذف إدخال التدريب؟",
	"DESCRIPTION": "وصف",
	"DETAILS": "التفاصيل",
	"DIRECTION": "اتجاه",
	"DISPLAY_NAME": "اسم",
	"DISTANCE": "المسافة",
	"DISTANCE_INDOOR": "المسافة الداخلية",
	"DISTANCE_OUTDOOR": "المسافة الخارجية",
	"DOWNLOAD": "تحميل",
	"DOWNLOAD_CARD": "بطاقة",
	"DOWNLOAD_RESULTS": "تنزيل النتائج",
	"DOWNLOAD_TRAINING_CARD": "بطاقة التدريب",
	"DOY": "موقع ضريبة القيمة المضافة",
	"EDIT": "تعديل",
	"EDIT_COACH": "تعديل المدرب",
	"EDIT_GAME": "تعديل المباراة",
	"EDIT_GAME_LEAGUES": "تعديل مباريات الفئة",
	"EDIT_GAME_LEAGUES_PLAYERS": "تعديل لاعبي الفئة",
	"EDIT_JUDGE": "تعديل حكم",
	"EDIT_LEAGUE": "تعديل الفئة",
	"EDIT_MATCH": "تعديل البطولة",
	"EDIT_PAYMENT": "تعديل الدفعة",
	"EDIT_PERMISSIONS": "تعديل الصلاحيات",
	"EDIT_PLAYER": "تعديل الرياضي",
	"EDIT_PLAYER_PAYMENT": " تعديل دفعة الرياضي ",
	"EDIT_ROLE": "تعديل الدور",
	"EDIT_ROLES": "تعديل الأدوار",
	"EDIT_STAFF": "تعديل الموظفين",
	"EDIT_TARGETS": "تعديل الاهداف",
	"EDIT_TEAM": "تعديل الفريق",
	"EDIT_TEAM_PAYMENT": " تعديل دفعة الفريق ",
	"EDIT_TRAINER": " تعديل المدرب ",
	"EDIT_TRAINING_CENTER": " تعديل مركز التدريب",
	"EDIT_TRANSFER_PLAYER": "تعديل انتقال اللاعب",
	"EDIT_USER": "تعديل المستخدم",
	"EDIT_USERS": "تعديل المستخدمين",
	"EFOT_REG": "كود الجهة",
	"ELIMINATION_INDIVIDUAL": "تصفيات الافراد",
	"ELIMINATION_INDIVIDUAL_LEAGUES": "تصفيات الافراد فئات",
	"ELIMINATION_MIXED_TEAM": "تصفيات فرق المختلط",
	"ELIMINATION_MIXED_TEAM_LEAGUES": "فئة تصفيات فرق المختلط",
	"ELIMINATION_PARTICIPANTS": "المشاركون",
	"ELIMINATION_ROUNDS": "التصفيات",
	"ELIMINATION_TEAM": "تصفيات الفرق",
	"ELIMINATION_TEAM_LEAGUES": "فئات تصفيات الفرق",
	"EMAIL": "البريد الإلكتروني",
	"EMPTY_ALL_TARGETS": "مسح جميع الأهداف",
	"EMPTY_SHOTS": "لديه تسديدات فارغة على الهدف ",
	"END": "انهاء",
	"ENDED": "منتهي",
	"ENDED_DATE": "انتهى الوقت",
	"END_TRAINING_ENTRY": "هل أنت متأكد من أنك تريد إنهاء الإدخال؟",
	"ENTER": "ادخال",
	"ENTRIES": "المدخلات",
	"ENTRIES_BY_TEAM": "التسجيلات حسب الفريق",
	"ENTRIES_PDF": "طباعة التسجيلات",
	"ENTRIES_PROOF": "** يرجى طباعة هذا أو اصطحابه معك في المباراة",
	"EOT": "الاتحاد السعودي للسهام",
	"EQUIPMENT": "معدات",
	"ERROR": "حدث خطأ ما ...",
	"ERROR_MONKEYS": "عفوا ، حدث خطأ ما",
	"EXISTS": "موجود مسبقا",
	"EXIT_GAME": "خروج",
	"EXPATRIATE": "وافد",
	"EXPIRED": "منتهي الصلاحية",
	"EXPORT_GAME": "تصدير البطولة",
	"EXTENSION_ERROR": "امتداد الملف غير مسموح به.",
	"F10s": "مجموع ال10",
	"F9s": "مجموع ال9",
	"FATHER": "الأب",
	"FATHER_NAME": "اسم الأب",
	"FAX": "فاكس",
	"FEMALE": "أنثى",
	"FIELD_1": "الحقل 1",
	"FIELD_2": "الحقل 2",
	"FIELD_3": "الحقل 3",
	"FILE_EXPLORER": "الملفات",
	"FILTERS": "مرشحات",
	"FINAL": "نهائي",
	"FINALIZE_MATCH": "إنهاء البطولة",
	"FINALIZE_ROUND_ONE": "إنهاء الجولة 1",
	"FINALIZE_ROUND_TWO": " إنهاء الجولة 2",
	"FINAL_SCORE": "النتيجة النهائية",
	"FINAL_SCORES": "النتائج النهائية",
	"FINAL_SHOT": "الرمية الاخيرة",
	"FINANCIAL": "مالي",
	"FINAl_SCORES_ROW": "النتائج النهائية",
	"FIRST_NAME": "الاسم الأول",
	"FNAME": "الاسم الأول",
	"FOR": "من أجل",
	"FORFEITED": " عدم الحضور",
	"FORGOT_PASSWORD_ENTER_EMAIL": "أدخل بريدك الإلكتروني وسنقوم بإعادة توجيه رسالة بريد إلكتروني تحتوي على التعليمات.",
	"FORGOT_YOUR_PASSWORD": "هل نسيت كلمة المرور؟",
	"FOR_YEAR": "للسنة",
	"FROM": "من",
	"FROM_TARGET": "من الهدف",
	"FROM_TEAM": "من ",
	"FROM_TO_EMPTY_FOR_ALL": "من - إلى",
	"FRONT": "أمام",
	"FULL_NAME": "الاسم الكامل",
	"FXs": " Xsمجموع ",
	"GAME": "البطولة",
	"GAME_DETAILS": "تفاصيل البطولة",
	"GAME_ENTRIES": "التسجيلات",
	"GAME_HISTORY": "سجل البطولة",
	"GAME_LEAGUES": "تفاصيل الفئة",
	"GAME_LOGOUT": "تسجيل الخروج من البطولة",
	"GAME_NAME": "اسم البطولة",
	"GAME_RESULTS": "نتائج البطولة",
	"GAME_STATS": "احصائيات البطولة",
	"GAME_TYPE": "نوع البطولة",
	"GGA_NUMBER": "الرقم الرسمي",
	"GOLD": "ذهبي",
	"GO_BACK": "الرجوع للخلف",
	"GO_TO_PROFILE": "ملف تعريف",
	"GRATZ_TO": "تهانينا ل",
	"GREAT": "عظيم",
	"GREEK": "Greek",
	"HAS_COACH": "هل لديك مدرب؟",
	"HEALTH": "كود الصحة",
	"HERE_ARE": "فيما يلي نتائج المسابقة التي شاركت فيها ",
	"HERE_ARE_TEAM": "فيما يلي نتائج المسابقة التي شارك فيها ناديك ",
	"HOST": "مضيف",
	"HOW_MANY": "كم عدد؟",
	"IDENTIFY_CODE": "رمز التعريف",
	"IDENTIFY_DATE": "تاريخ الهوية",
	"IMAGE": "صورة",
	"IMPORT_GAME": "استيراد البطولة",
	"IMPORT_OLD_GAMES": "استيراد البطولات القديمة",
	"IMPORT_SCORES": "استيراد النتائج",
	"INCREMENT_SCORE": "درجة الزيادة",
	"INC_SCORE": "زيادة النتيجة",
	"INDEX": "الصفحة الرئيسية",
	"INDIVIDUAL": "فردي",
	"INDIVIDUAL_OLYMPIC": "جولات الإقصاء الفردية",
	"INDOOR": "داخلي",
	"INFO": "معلومات",
	"INFORMATION": "معلومات",
	"INFO_GAME": "معلومات البطولة",
	"JUDGE": "الحكم",
	"JUDGES": "الحكام",
	"JUDGE_CANDIDATE": "الحكم المرشح",
	"JUDGE_INTERNATIONAL": "حكم دولي",
	"JUDGE_LEVEL": "مستوى الحكم",
	"JUDGE_NATIONAL": "حكم محلي",
	"JUDGE_PROFILE": "ملف تعريف للحكم",
	"JUDGE_STAFF": "فريق التحكيم",
	"LAST_NAME": "اسم العائلة",
	"LEAGUE": "الفئة",
	"LEAGUES": "الفئات",
	"LEAGUES_LIST": "التسجيلات حسب الفئة",
	"LEAGUE_CAT": "تصنيف الفئة",
	"LEAGUE_CODE": "كود الفئة",
	"LEAGUE_ELIMINATIONS_ELIGIBILITY": " أهلية تصفيات الفئة ",
	"LEAGUE_NAME": "اسم الفئة",
	"LEAGUE_ORDER": "الترتيب",
	"LEAGUE_SEX": "الجنس",
	"LEAGUE_SORT_NAME": "اسم المختصر",
	"LEAGUE_TYPE": "النوع",
	"LEVEL": "المستوى",
	"LIMBS": "الاذرعة",
	"LIMIT_INDOOR": "حد البطولات الداخلية",
	"LIMIT_OUTDOOR": " حد البطولات الخارجية ",
	"LIST_BY_TEAM": "قائمة الفرق",
	"LIST_ENTRIES": "قائمة التسجيلات",
	"LIST_GAMES": "قائمة البطولات",
	"LIST_LEAGUES": "قائمة الفئات",
	"LIST_PAYMENT_MOVEMENTS_PLAYERS": "مدفوعات الرياضيين",
	"LIST_PAYMENT_MOVEMENTS_TEAMS": "مدفوعات الفريق",
	"LIST_PLAYERS": "قائمة الرياضيين",
	"LIST_TEAMS": "قائمة الفرق",
	"LIST_TRANSFERS": "قائمة الانتقالات",
	"LIVESCORES": "نتائج مباشرة",
	"LNAME": "اسم العائلة",
	"LOAD_ALL_PLAYERS": "تحميل جميع الرياضيين",
	"LOAD_FINANCIAL_OK_PLAYERS": "تحميل اللاعبين المسددين للرسوم ",
	"LOCATION": "مكان",
	"LOGOUT": "تسجيل خروج",
	"MALE": "ذكر",
	"MAP_LOCATION": "الموقع",
	"MATCHES": "البطولات",
	"MATCH_CHAMPIONSHIP": "البطولة",
	"MATCH_CODE": "كود البطولة",
	"MATCH_COMMITTEE": "لجنة البطولة",
	"MATCH_CUP": "كاس البطولة",
	"MATCH_DATE": "تاريخ البطولة",
	"MATCH_ELIGIBILITY_EXPLAIN_TEXT": "لا يمكنك تسجيل الرياضي لهذه البطولة للأسباب التالية:",
	"MATCH_ENTRIES_LIMIT": "حد إدخالات البطولة",
	"MATCH_HOST": "مضيف",
	"MATCH_ID": "كود البطولة",
	"MATCH_JUDGE": "حكم البطولة",
	"MATCH_LEAGUES": "فئات البطولة",
	"MATCH_LOCATION": "موقع البطولة",
	"MATCH_NAME": "اسم البطولة",
	"MATCH_OFFICIAL": "اداري البطولة",
	"MATCH_OVERVIEW": "نظرة عامة على البطولة",
	"MATCH_REGISTRATION_END": "تاريخ إغلاق التسجيل",
	"MATCH_REGISTRATION_START": "تاريخ فتح باب التسجيل",
	"MATCH_REPRESENTER": "ممثل البطولة",
	"MATCH_RESULTS": "نتائج البطولة",
	"MATCH_SORT_NAME": "فرز الاسم",
	"MATCH_TYPE": "نوع",
	"MEDAL": "ميدالية",
	"MEDALS": "الميداليات",
	"MEDALS_FROM_OLYMPIC": "ميداليات من جولات الإقصاء",
	"MEDALS_FROM_QUALIFICATIONS": "ميداليات من التأهيل",
	"MEN": "ذكر",
	"MENU": "قائمة",
	"MENU_SETTINGS": "إعدادات القائمة",
	"MIXED": "مختلط",
	"MIXED_LEAGUE": "فئة المختلط",
	"MIXED_TEAM": "فرق المختلط",
	"MIXED_TEAM_OLYMPIC": "جولات إقصاء الفرق المختلطة",
	"MOBILE_SCORING_ROUND_1_OPEN": "السماح بالتسجيل من الهواتف المحمولة (الجولة 1)",
	"MOBILE_SCORING_ROUND_2_OPEN": "السماح بالتسجيل من الهواتف المحمولة ( الجولة 2 )",
	"MONEY_CHECK": "فحص",
	"MOTHER": "الأم",
	"MOTHER_NAME": "اسم الأم",
	"MOVEMENT_REPORT": "تقرير الحركات",
	"MOVE_BACK": "العودة إلى الخلف",
	"MOVE_FRONT": "التحرك للأمام",
	"MOVE_GAME": "نقل البطولة",
	"MOVE_MATCH": "نقل البطولة",
	"MOVE_PLAYER": "نقل الهدف",
	"MOVE_TARGETS": "نقل الأهداف",
	"MRS": "عزيزي السيد / السيدة",
	"NAME": "اسم",
	"NATIONAL": "وطني",
	"NATIONALITY": "الجنسية",
	"NATIONAL_TEAM": "الفريق الوطني",
	"NEANIDWN": "البنات",
	"NEW_HEALTH": "جواز سفر جديد",
	"NEW_HEALTH_SORT": "رقم صحي جديد",
	"NEW_MATCH": "بطولة جديدة",
	"NEW_PASSWORD": "كلمة مرور جديدة",
	"NEW_PASSWORD_CONFIRMATION": "كلمة مرور جديدة (تأكيد)",
	"NEW_TEAM": "فريق جديد",
	"NEW_TRANSFER": "نقل جديد",
	"NEW_TRANSFER_PLAYER": "انتقال رياضي جديد",
	"NEXT": "التالي",
	"NEXT_ROUND": "الجولة التالية",
	"NO": "لا",
	"NOTES": "ملاحظات",
	"NOT_AVAILABLE": "غير متوفر",
	"NOT_ENOUGH_PLAYERS": "الفريق ليس لديه ما يكفي من الرياضيين للمشاركة",
	"NOT_FOUND": "لم يتم العثور على استخدام الرمز",
	"NOT_PAID": "غير مدفوع",
	"NOT_VALID": "غير صالح",
	"NOW_ELIGIBLE": "يمكن الآن المنافسة في",
	"NO_FOR_OLYMPIC": "عدد الرياضيين لجولة الإقصاء",
	"NO_FOR_OLYMPIC_TEAMS": "# من الفرق لجولات الإقصاء",
	"NO_IMAGE": "حدد صورة أولا.",
	"NO_MORE_ENTRIES_AVAILABLE": "لا مزيد من الإدخالات المتاحة",
	"NO_RESULTS": "لم يتم العثور على نتائج",
	"NO_TEAM_YEAR_PAYMENT_MADE": "لم يقم النادي الرياضي بالدفع السنوي",
	"NO_YEAR_PAYMENT_MADE": " لم يقم الرياضي بالدفع السنوي ",
	"NUMBER": "#",
	"O/I": "",
	"OAKA_TRAINING_CENTER": "مركز تدريب",
	"OFFICIAL": "رسمي",
	"OFFICIAL_SCORE": "النتيجة الرسمية",
	"OLD_HEALTH": "جواز السفر القديم",
	"OLD_HEALTH_SORT": "الرقم الصحي القديم",
	"OLD_TEAM": "الفريق القديم",
	"OLYMPIC": "جولات الإقصاء",
	"OLYMPIC_ROUNDS_INDIVIDUAL": "الإقصاءات الفردية",
	"OLYMPIC_ROUNDS_TEAM": "إقصاءات الفريق",
	"OLYMPIC_TEAM_MIXED": "إقصاءات فريق مختلط",
	"OL_TEAM": "فريق",
	"ONE_PLAYER": "رياضي واحد",
	"OPEN": "مفتوح",
	"ORDER_BY": "ترتيب حسب",
	"OTHER": "آخر",
	"OUTDOOR": "خارجي",
	"OVERRIDE_AGE_LIMITS": "تجاوز حدود العمر",
	"OVERRIDE_CHECKS": "تجاوز جميع المراجعات",
	"OVERRIDE_LIMITS": "حدود التجاوز (العمر والنتيجة)",
	"OVERVIEW": "نظرة عامة على البطولة",
	"PAID": "مدفوع",
	"PASSED_LIMIT": "تجاوز الحد",
	"PASSPORT": "جواز سفر",
	"PASSPORTS": "جوازات السفر",
	"PASSWORD": "كلمة المرور",
	"PAUSE": "ايقاف",
	"PAUSED": "متوقف",
	"PAUSE_TRAINING_ENTRY": "هل أنت متأكد من أنك تريد إيقاف الإدخال مؤقتا؟",
	"PAYMENT": "دفع",
	"PAYMENTS": "الدفعات",
	"PAYMENT_DATE": "تاريخ الحركة",
	"PAYMENT_EDIT_FAIL": "فشل التعديل",
	"PAYMENT_EDIT_SUCCESSFULL": "تم التعديل بنجاح",
	"PAYMENT_FAILED": "فشل الدفع",
	"PAYMENT_ITEMS": "المدفوعات",
	"PAYMENT_REASON": "وصف الدفع",
	"PAYMENT_REASON_EMPTY_FOR_ALL": "الدفع (فارغ للجميع)",
	"PAYMENT_REPORT": "تقرير الدفع",
	"PAYMENT_SUCCESSFULL": "ناجح",
	"PC": "الرمز البريدي",
	"PDF": "PDF",
	"PDF_RIGHTS": "* حذر ، قد تختلف النتائج عن اللقطات الفعلية",
	"PHONE": "الهاتف",
	"PHOTO_SIZE_ERROR": "صور تصل سعتها إلى 2 ميجابايت",
	"PICK": "اختار",
	"PICK_CATEGORY": "اختر التصنيف",
	"PICK_GAME": "اختر البطولة",
	"PICK_LEAGUE": "اختر الفئة",
	"PICK_LEAGUE_ADD": "حدد الفئة لإضافتها",
	"PICK_LEAGUE_DEL": " حدد الفئة لحذفها ",
	"PICK_PLAYER": "اختر لاعب",
	"PICK_PLAYER_EMPTY_FOR_ALL": " لاعب (فارغ للجميع)",
	"PICK_ROUND": "حدد الجولة",
	"PICK_TARGET": "اختر الهدف",
	"PICK_TEAM": "اختر الفريق",
	"PICK_TEAM_EMPTY_FOR_ALL": "فريق (فارغ للجميع)",
	"PLAYER": "اللاعب",
	"PLAYER/ER": "اللاعب",
	"PLAYERS": "اللاعبين",
	"PLAYERS_LIST": "التسجيلات حسب اللاعبين",
	"PLAYERS_PER_TARGET": "اللاعبين حسب الهدف",
	"PLAYERS_REGISTERD": "اللاعبين المسجلين",
	"PLAYER_1": "الرياضي 1",
	"PLAYER_2": "الرياضي 2",
	"PLAYER_3": "الرياضي 3",
	"PLAYER_LEAGUES": "بطولات اللاعب",
	"PLAYER_MATCHES": "بطولات اللاعبين",
	"PLAYER_NAME": "اسم اللاعب",
	"PLAYER_ONE": "الرياضي #1",
	"PLAYER_PASSPORT": "الرياضي جواز سفر",
	"PLAYER_PAYMENTS": "الرياضي مدفوعات",
	"PLAYER_PAYMENTS_FULFILLMENT": " وفاء الرياضي بالمدفوعات",
	"PLAYER_PAYMENTS_LIST": "الرياضي مدفوعات",
	"PLAYER_PAYMENT_REPORT": "الرياضي تقرير الدفع",
	"PLAYER_PROFILE": "الرياضي ملف تعريف",
	"PLAYER_THREE": "الرياضي #3",
	"PLAYER_TWO": "الرياضي #2",
	"PLUGINS": "الإضافات",
	"POSITION": "المنصب",
	"POSTAL_CODE": "الرمز البريدي",
	"PREVIOUS": "السابق",
	"PRICE": "المبلغ",
	"PRINT": "اطبع",
	"PRINTS": "طباعة",
	"PRINT_DEGREES": "طباعة الدرجات",
	"PRINT_ENTRIES_PDF": "طباعة التسجيلات",
	"PRINT_ENTRIES_PDF_SPECIFIC": "طباعة تسجيلات الفريق",
	"PRINT_GAME_BOOK": "طباعة دفتر البطولة",
	"PRINT_GAME_DETAILS": "طباعة تفاصيل البطولة",
	"PRINT_GAME_PDF": "طباعة التصفيات",
	"PRINT_GAME_PDF_AFTER_GAME": "طباعة التصفيات بعد البطولة ",
	"PRINT_GAME_PDF_MEDALS": "طباعة الميداليات",
	"PRINT_GAME_PDF_MEDALS_OLYMPIC": "طباعة الميداليات",
	"PRINT_GAME_PLAYERS": "طباعة الرياضيين بالبطولة",
	"PRINT_GAME_PLAYERS_PDF": "طباعة اللاعبين",
	"PRINT_GAME_PLAYERS_TEAMS": "طباعة اللاعبين حسب الفرق",
	"PRINT_GAME_TARGETS": "طباعة الاهداف",
	"PRINT_OLMPIC_LAYOUT": "طباعة شجرة التصفيات",
	"PRINT_OLYMPIC_ROUNDS": " طباعة جولات التصفيات ",
	"PRINT_PDF": "طباعة",
	"PRINT_REGISTRATIONS_PDF": "طباعة التسجيلات",
	"PRINT_RESULTS": "طباعة النتائج",
	"PRODUCE_TARGETS": "Product Targets",
	"PROFILE": "الملف التعريفي",
	"QR": "QR",
	"QUALIFICATION": "التصفيات",
	"QUALIFICATION_INDIVIDUAL": "التصفيات الفردية",
	"QUALIFICATION_MIXED_TEAM": "تصفيات فرق المختلط",
	"QUALIFICATION_TEAM": "تصفيات الفرق",
	"RANK": "الترتيب",
	"REAL_LIVESCORES": "النتائج المباشرة",
	"RECOVER_SUCCESS": "إذا تم العثور على المستخدم يتم إرسال بريد إلكتروني.",
	"RECURVE": "القوس المحدب",
	"RECURVE_JM_JW": "القوس المحدب ناشئين اولاد - بنات",
	"RECURVE_LEVEL": "مستوى القوس المحدب",
	"RECURVE_M_W": "القوس المحدب رجال - نساء ",
	"RECURVE_YM_YW": " القوس المحدب شباب اولاد - بنات ",
	"REGION": "المنطقة",
	"REGISTRAION_CLOSED_TEXT": "التسجيل مغلق. لا يمكنك إجراء أي تغييرات. يرجى الاتصال info@saaf.sa لأية طلبات.",
	"REGISTRATIONS": "التسجيلات",
	"REGISTRATION_CLOSED": "التسجيل مغلق",
	"REGISTRATION_CLOSED_TEXT_LIST": "فيما يلي قائمة بالرياضيين الذين قمت بتسجيلهم. التسجيل مغلق الآن. لا يمكنك إجراء أي تغييرات. يرجى الاتصال بنا للحصول على أي نوع من المعلومات التي قد تحتاجها.",
	"REGISTRATION_DATE": "تاريخ التسجيل",
	"REGISTRATION_END_DATE": "تاريخ انتهاء التسجيل",
	"REGISTRATION_IS_CLOSED": "التسجيل مغلق.",
	"REGISTRATION_OPEN": "التسجيل مفتوح",
	"REGISTRATION_OPEN_DATE": "تاريخ فتح باب التسجيل",
	"REGISTRATION_STATUS": "حالة التسجيل هي ",
	"REG_DATE": "تاريخ التسجيل",
	"REMOVE": "إزالة",
	"REMOVE_LEAGUE": "إزالة البطولة",
	"REMOVE_PLAYERS": "إزالة الرياضيين",
	"REMOVE_PLAYERS_FROM_MATCH": "إزالة الرياضيين من البطولة",
	"REPORTS": "التقارير",
	"REPORT_1": "الرياضيين حسب الفريق",
	"REPORT_10": "أفضل رمايات لكل رياضي / فريق / فئة",
	"REPORT_11": "اللاعبين #2",
	"REPORT_12": "الفرق #2",
	"REPORT_2": "الفرق",
	"REPORT_3": "الرياضيون المسجلون لكل فريق",
	"REPORT_4": "البطولات والمدخلات",
	"REPORT_5": "اللاعبين المسجلين بالفئة",
	"REPORT_6": " اللاعبين المسجلين بالفرق ",
	"REPORT_7": "نتائج اللاعبين",
	"REPORT_8": "اكثر الرياضيين / الفرق الفائزة",
	"REPORT_9": "المسجلين بمركز التدريب",
	"REPORT_13": "Medals",
	"REPORT_OF_YEAR": "تقرير المدفوعات للسنة : ",
	"REPRESENTER": "الممثل",
	"REQUIRED_BY_PLAYER": "مطلوب من قبل الرياضي",
	"REQUIRED_BY_TEAM": "مطلوب من قبل الفريق",
	"REQUIRED_FIELDS": "الحقول التي تحتوي على * مطلوبة",
	"REQUIRED_PLAYER": "مطلوب من قبل الرياضيين للمشاركة في البطولات",
	"REQUIRED_TEAM": "مطلوب من قبل الفرق للمشاركة في البطولات",
	"RESET_PASSWORD": "كلمة مرور جديدة",
	"RESTORE_PAYMENT": "استعادة الدفع",
	"RETURN_TO": "عودة إلى ",
	"RISER": "مقبض",
	"ROLE": "الدور",
	"ROLES": "الادوار",
	"ROUND": "جولة",
	"ROUNDS": "جولات",
	"ROUND_1": "جولة 1",
	"ROUND_1/RANK": "الجولة 1 / الترتيب",
	"ROUND_1/RANKs": "الترتيب العام 1",
	"ROUND_2": " الجولة 2 ",
	"ROUND_2/RANK": " الجولة 2 / الترتيب ",
	"ROUND_2/RANKs": " الترتيب العام 2",
	"ROUND_ONE": " الجولة 1 ",
	"ROUND_TWO": " الجولة 2 ",
	"RUNNING_TOTAL": "المجموع الجاري حاليا",
	"SAVE_MATCH_TEAM_INFO": "حفظ معلومات الفرق بالبطولة",
	"SCHOOL": "المدرسة",
	"SEARCH_GAME_NAME": "بحث...",
	"SEARCH_LEAGUE_NAME": "بحث...",
	"SEARCH_NAME": "البحث حسب الرياضي",
	"SEARCH_TEAM": "البحث حسب الفريق",
	"SEARCH_TEAM_NAME": "بحث...",
	"SELECT": "اختار",
	"SELECT_ALL": "حدد الكل",
	"SELECT_CITIZENSHIP": "اختر الجنسية",
	"SELECT_COUNTY": "اختر المنطقة",
	"SELECT_ELIMINATION_PARTICIPANTS": "تحديد المشاركين",
	"SELECT_FILE": "اختر الملف",
	"SELECT_JUDGES": "اختيار الحكام",
	"SELECT_LEAGUE": "اختر الفئة",
	"SELECT_LEAGUES": "اختر الفئات ",
	"SELECT_LEVEL": "اختر الفئات ",
	"SELECT_MATCH": "اختر البطولة",
	"SELECT_NATIONALITY": "اختر الجنسية",
	"SELECT_NEW_TEAM": "اختر فريقا جديدا",
	"SELECT_PAYMENT": "اختر الدفع",
	"SELECT_PERMISSIONS": "تحديد الأذونات",
	"SELECT_PLAYER": "اختر اللاعب",
	"SELECT_REGION": "إختر المنطقة",
	"SELECT_ROLE": "حدد الدور",
	"SELECT_ROUND": "حدد الجولة",
	"SELECT_SEX": "اختر الجنس",
	"SELECT_STATE": "اختر الولاية",
	"SELECT_TARGET": "اختر الهدف",
	"SELECT_TEAM": "اختر الفريق",
	"SELECT_TRAINING_CENTER": "اختر مركز التدريب",
	"SELECT_YEAR": "اختر السنة",
	"SEND_MESSAGE": "ارسل رسالة",
	"SEND_PLAYER_EMAILS": "ارسل ايميل للاعبين",
	"SETTINGS": "الاعدادات",
	"SET_POINTS": "نقاط المجموعة",
	"SET_TOTAL": "اجمالي المجموعة",
	"SEX": "جنس",
	"SHOT_1": "الرمية 1",
	"SHOT_10": "الرمية 10",
	"SHOT_2": " الرمية 2",
	"SHOT_3": " الرمية 3",
	"SHOT_4": " الرمية 4",
	"SHOT_5": " الرمية 5",
	"SHOT_6": " الرمية 6",
	"SHOT_7": " الرمية 7",
	"SHOT_8": " الرمية 8",
	"SHOT_9": " الرمية 9",
	"SHOT_NOW": "الرمية الحالية",
	"SHOT_NUMBER_NOW": "رقم الرمية الحالية",
	"SHOT_SCORE": "نتيجة الرمية",
	"SHOT_SCORE_SO_FAR": "النتيجة حتى الآن",
	"SIGNER": "صاحب التوقيع",
	"SIGN_IN": "تسجيل الدخول",
	"SILVER": "فضي",
	"SORT_LEAGUE_NAME": "الفرز باسم البطولة",
	"SORT_NAME": "الفرز الاسم",
	"STAFF": " الموظفين",
	"STAFF_PROFILE": "ملف التعريفي للموظفين ",
	"START": "ابدأ",
	"STARTED_DATE": "بدأ الوقت",
	"STARTING_FROM_TARGET": "ابتداء من",
	"STARTING_ROUND": "جولة البداية",
	"START_AUTOSCREOLLING": "ابدأ بالتمرير التلقائي",
	"START_AUTOSCROLL": "ابدأ بالتمرير التلقائي",
	"START_DATE": "تاريخ البدء",
	"START_ENTRY": "بدء التسجيل",
	"START_TRAINING_ENTRY": "هل أنت متأكد من أنك تريد استخدام المدخلات؟",
	"STATE": "حالة",
	"STATS": "احصائيات",
	"STATS_FOR_PLAYER": "حالة اللاعب",
	"STATS_FOR_TEAM": "حالة الفريق",
	"STATUS": "الحالات",
	"STOP_AUTOSCROLL": "إيقاف التمرير التلقائي",
	"STOP_AUTOSCROLLING": "إيقاف التمرير التلقائي",
	"STUDENT": "طالب",
	"STUDENT_TEAM": "فريق الطلاب",
	"SUBMIT": "تسجيل",
	"SUBMIT_EXIT": "التسجيل ثم الخروج",
	"SUBMIT_NEXT": "التسجيل ثم الهدف التالي",
	"SUBMIT_RETURN": "التسجيل والرجوع",
	"SUCCESS": "نجاح",
	"SUGGESTED": "مقترح",
	"SUM": "مجموع",
	"SUSPEND_REASON": "سبب",
	"SUSPEND_TEAM": "تعليق الفريق",
	"SWAP_PLAYERS": "مبادلة الرياضيين",
	"SWAP_TARGETS": "أهداف المبادلة",
	"TARGET": "هدف",
	"TARGETS": "اهداف",
	"TARGETS_BOARDS": "لوحات الاهداف",
	"TARGETS_LIST": "التسجيلات حسب الأهداف",
	"TARGETS_NUMBER": "عدد الأهداف",
	"TARGETS_WITH_EMPTY_SHOTS": "الأهداف الخالية من الرميات",
	"TARGET_BOARDS": "لوحات الهدف",
	"TARGET_FROM": "الأهداف من",
	"TARGET_NAME": "رقم الهدف",
	"TARGET_TO": "الى",
	"TARGET_TWO": "#2 الهدف ",
	"TEAM": "فريق",
	"TEAMS": "الفرق",
	"TEAMS_LIST": "التسجيلات حسب الفريق",
	"TEAM_ENTRIES_LIST": "الإدخالات لكل فريق",
	"TEAM_INFO": "معلومات الفريق",
	"TEAM_IS_SUSPENDED": "لا يمكنك تسجيل الرياضيين في هذه اللحظة.",
	"TEAM_IS_SUSPENDED_PROFILE": "تم تعليق هذا الفريق.",
	"TEAM_NAME": "اسم الفريق",
	"TEAM_OLYMPIC": "جولات إقصاء الفريق",
	"TEAM_PAYMENTS": "مدفوعات الفريق",
	"TEAM_PAYMENTS_LIST": "مدفوعات الفريق",
	"TEAM_PROFILE": "ملف تعريف الفريق",
	"TEAM_REPORT_NAME": "اسم: ",
	"TEAM_SORT_NAME": "فرز الاسم",
	"TEAM_S_NAME": "فريق",
	"TEENS": "الاولاد",
	"THERE_ARE_TOTAL": "مجموع ",
	"TITLE": "عنوان",
	"TOP_2_PLAYERS": "أفضل 2 رياضيين لكل فئة",
	"TOP_SCORE_IN_LEAGUE": "اعلى نتيجة بالفئة",
	"TOTAL": "مجموع",
	"TOTAL/RANK": "المجموع / الترتيب",
	"TOTAL/RANKs": "مجموع",
	"TOTAL_AMOUNT_MOVED": "المبلغ الإجمالي : ",
	"TOTAL_ENTRIES": "إجمالي المدخلات",
	"TOTAL_ENTRIES_IN_LEAGUE": "اجمالي الادخالات بالفئة",
	"TOTAL_MOVEMENTS": "مجموع الحركات : ",
	"TOTAL_PLAYERS": "مجموع الرياضيين",
	"TOTAL_SCORE": "مجموع النقاط",
	"TOTAL_SCORE_POINTS": "النقاط",
	"TO_TARGET": "الى الهدف",
	"TO_TEAM": "الى ",
	"TRAINERS": "المدربين",
	"TRAINER_0_LEVEL": "مدرب مبتدئ",
	"TRAINER_1_LEVEL": "مدرب مستوى 1",
	"TRAINER_2_LEVEL": " مدرب مستوى 2",
	"TRAINER_3_LEVEL": " مدرب مستوى 3",
	"TRAINER_LEVEL": "مستوى المدرب",
	"TRAINER_PROFILE": "الملف الشخصي للمدرب",
	"TRAINING_CENTER": "مركز تدريب",
	"TRAINING_CENTERS": "مراكز التدريب",
	"TRAINING_ENTRIES": "إدخالات التدريب",
	"TRANSFER": "نقل",
	"TRANSFERS": "انتقالات",
	"TRANSFER_DATE": "تاريخ الانتقال",
	"TRANSFER_FAIL": "فشل النقل",
	"TRANSFER_PLAYER": "انتقال اللاعب",
	"TRANSFER_SUCCESSFUL": "تم النقل بنجاح",
	"TRUELIVE_ALL": "النتائج",
	"TRUELIVE_CAT": "النتائج",
	"TYPE": "نوع",
	"UNIQUE_ENTRIES": "إدخالات فريدة",
	"UNKNOWN": "خطأ غير معروف عند التحميل.",
	"UNPAUSE": "إلغاء الإيقاف المؤقت",
	"UNPAUSE_TRAINING_ENTRY": "هل أنت متأكد من أنك تريد إلغاء إيقاف الإدخال مؤقتا؟",
	"UPDATED_AT": "تم التحديث في",
	"UPDATE_GAME": "تحديث البطولة",
	"UPDATE_PLAYER_LEAGUE": "تحديث فئات الرياضيين",
	"UPDATE_ROUND_1": "تحديث الجولة 1",
	"UPDATE_ROUND_2": "تحديث الجولة 2",
	"UPDATE_TEAM_LEAGUE_PLAYERS": "تحديث فئات لاعبي الفريق",
	"UPLOAD_FAILED": "فشل التحميل.",
	"UPLOAD_RESULTS_PDF": "تحديث النتائج",
	"USER": "مستخدم",
	"USERNAME": "اسم المستخدم",
	"USERS": "المستخدمون",
	"USER_ROLE": "الدور",
	"VALID": "فعال",
	"VALIDATE_PASSPORT": "التحقق من فعالية البطاقة ( السنة الحالية )",
	"VALIDATE_PASSPORTS": "التحقق من صحة البطاقات ( السنة الحالية )",
	"VALID_UNTIL": "صالح حتى",
	"VAT": "ضريبه القيمه المضافه",
	"VIEW_REGISTRATION": "عرض التسجيلات",
	"WEB": "الموقع الإلكتروني",
	"WELCOME_TO": "مرحبا بكم في ",
	"WINNER": "الفائز",
	"WOMEN": "أنثى",
	"YEAR": "سنة",
	"YES": "نعم",
	"YOUR_EMAIL": "بريدك الإلكتروني",
	"addCoach": "إضافة مدرب",
	"addGame": "إضافة بطولة ",
	"addJudge": "إضافة حكم",
	"addLeague": "إضافة فئة ",
	"addPaymentPlayer": "إضافة دفعة للاعب",
	"addPaymentReason": "إضافة سبب الدفع",
	"addPaymentTeam": "إضافة دفعة للفريق",
	"addPlayer": "إضافة لاعب",
	"addPlayersToMatch": "إضافة رياضيين إلى البطولة",
	"addShotsToGame": "إضافة رميات إلى البطولة",
	"addShotsToOlympic": "إضافة رميات إلى جولات الإقصاء",
	"addStaff": "إضافة موظفين",
	"addTeam": "إضافة نادي",
	"addTrainer": "إضافة مدرب",
	"addTrainingCenter": "إضافة مركز تدريب جديد",
	"addTrainingEntry": "إضافة دخول مركز التدريب",
	"calendar": "تقويم",
	"changeTeamPassword": "تغيير كلمة مرور النادي",
	"checkInPlayerToMatch": "تسجيل اللاعب بالبطولة",
	"deleteCoach": "حذف المدرب",
	"deleteGame": "حذف الحدث",
	"deleteJudge": "حذف الحكم",
	"deleteLeague": "حذف الفئات",
	"deletePlayer": "حذف اللاعب",
	"deleteStaff": "حذف الموظف",
	"deleteTeam": "حذف النادي",
	"deleteTrainer": "حذف المدرب",
	"deleteTrainingCenter": "حذف مركز التدريب",
	"deleteTrainingEntry": "حذف إدخال مركز التدريب",
	"editCoach": "تعديل المدرب",
	"editGame": "تعديل البطولة",
	"editGameLeagues": "تعديلات فئات البطولة",
	"editGamePlayerLeague": "تعديلات فئات اللاعبين للبطولة",
	"editGameTargets": "تعديل أهداف البطولة",
	"editJudge": "تعديل الحكم",
	"editLeague": "تعديل الفئة",
	"editPlayer": "تعديل اللاعب",
	"editRoles": "تعديل الأدوار",
	"editStaff": "تعديل الموظفين",
	"editTeam": "تعديل النادي",
	"editTrainer": "تعديل المدرب",
	"editTrainingCenter": "تعديل مركز التدريب",
	"editTrainingEntry": "تعديل إدخال مركز التدريب",
	"editUsers": "تعديل المستخدمين",
	"files": "الملفات",
	"gameUpdate": "Update event",
	"indoor": "داخلي",
	"livescores": "النتيجة المباشرة",
	"makePlayerTransfer": "إضافة نقل رياضي",
	"matchPrints": "مطبوعات الفعالية",
	"moveGame": "نقل الفعالية",
	"olympic": "جولات الإقصاء",
	"outdoor": "خارجية",
	"overrideMatchFilters": "تجاوز فلاتر البطولة",
	"passportValidate": "تحديث المستند",
	"playerTransfers": "الانتقالات",
	"removePlayersFromMatch": "إزالة اللاعبين من البطولة",
	"settings": "اعدادات",
	"stats": "الاحصاءات",
	"trainingCenters": "مراكز التدريب",
	"viewAllCoaches": "عرض جميع المدربين",
	"viewAllJudges": "عرض جميع الحكام",
	"viewAllLeagues": "عرض جميع الفئات",
	"viewAllMovementsPlayers": "عرض جميع مدفوعات اللاعبين",
	"viewAllMovementsTeams": "عرض جميع مدفوعات النادي",
	"viewAllPlayers": "عرض جميع اللاعبين",
	"viewAllStaff": "عرض جميع الموظفين",
	"viewAllTeams": "عرض جميع الأندية",
	"viewAllTrainers": "عرض جميع المدربين",
	"viewAllTrainingCenters": "عرض مراكز التدريب",
	"viewAllTrainingEntries": "عرض جميع إدخالات مراكز التدريب",
	"viewAllTransfers": "عرض جميع الانتقالات",
	"viewFinancial": "عرض البيانات المالية",
	"viewReports": "عرض التقارير",
	"viewUsers": "عرض المستخدمين",
	"PLAYER_AGE": "Age",
	"AGE_FROM": "Age (From)",
	"AGE_TO": "Age (To)",
	"paraArchery": "ذوي الإعاقة",
	"CERTIFICATES": "Certificates",
	"MATCH_CITY": "City",
	"MATCH_END_DATE": "Match End date",
	"ATHLETE_MATCH_ENTRY_CARDS": "Athlete Match Entry Cards",
	"BOARDS": "Boards",
	"ADD_SHOTS_VISUAL_ELIMINATIONS": "Eliminations Visual"
};


//////////////////
// WEBPACK FOOTER
// ./client/app/translations/ar.json
// module id = 1086
// module chunks = 0